if (typeof FeaturedReviewsCarousel === 'undefined') {
    class FeaturedReviewsCarousel extends HTMLElement {
        connectedCallback() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            // Bind resize handler
            this.handleResize = this.handleResize.bind(this);
            
            // Set initial offset
            this.updateOffsetLeft();

            whenReady('Swiper', () => {
                try {
                    this.initializeCarousel(swiperContainer);
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });

            // Add resize listener
            window.addEventListener('resize', this.handleResize);
        }

        initializeCarousel(swiperContainer) {
            const sliderOptions = {
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 10,
                watchSlidesProgress: true,
                mousewheel: {
                    forceToAxis: true
                },
                a11y: true,
                modules: [window.Swiper.Mousewheel, window.Swiper.A11y],
            };
            
            this.swiper = new window.Swiper(swiperContainer, sliderOptions);
        }

        updateOffsetLeft() {
            const rect = this.getBoundingClientRect();
            const offsetLeft = rect.left + window.scrollX;
            this.closest(".featured-reviews__grid-items").style.setProperty('--offset-left', `${offsetLeft}px`);
        }

        handleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.updateOffsetLeft();
            }, 150);
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }

            // Remove resize listener
            window.removeEventListener('resize', this.handleResize);

            // Clear any pending timeout
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }
    }

    if (!window.customElements.get('featured-reviews-carousel')) {
        window.customElements.define('featured-reviews-carousel', FeaturedReviewsCarousel);
    }
}
